<div *ngIf="changes && changes.length" class="alert alert-warning">
  <div *ngFor="let change of changes">
    <p>The keywords have been changed from</p>
    <p>{{ change.before }}</p>
    <p>to</p>
    <p>{{ change.after }}</p>
    <p>on {{ change.date | date : 'short' }}.</p>
  </div>
  <strong>This task may have been partially completed by another writer, but you are responsible for the quality of the entire piece</strong>
</div>